import { ChannelRequest as Api } from '@synapex/shared2/gateway-rest-api/advertiser-account';

import { api } from '@/shared/api';

import * as ReplyParser from './reply-parser';

export const getOne = (
  params: Api.getOne.Params,
  abortController?: AbortController,
) =>
  api
    .get<Api.getOne.Reply>(
      Api.getOne.path(params),
      abortController
        ? {
            signal: abortController.signal,
          }
        : {},
    )
    .then((reply) => {
      if (reply.status === 'ACCOUNT') {
        return {
          status: reply.status,
          telegram_channel_id: reply.telegram_channel_id,
          advertiserAccount: ReplyParser.createdReply(reply.advertiserAccount),
        };
      } else if (reply.status === 'CHANNEL') {
        return {
          status: reply.status,
          channel: ReplyParser.channel(reply.channel),
        };
      } else {
        return reply;
      }
    });
